import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-3 p-3" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm font-medium text-center mb-6 animate__animated animate__fadeIn"
}
const _hoisted_3 = { class: "flex flex-wrap -mt-5" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex flex-row w-full justify-between items-center animate__animated animate__fadeIn" }
const _hoisted_7 = { class: "text-2xl font-extralight py-1 w-9/12" }
const _hoisted_8 = {
  key: 0,
  class: "text-sm font-bold px-3 py-2 rounded-full border-2 border-green-400 text-center text-green-500"
}
const _hoisted_9 = { class: "w-full py-2" }
const _hoisted_10 = {
  key: 0,
  class: ""
}
const _hoisted_11 = {
  key: 0,
  class: "flex flex-row justify-between items-center bg-primary-light rounded-2xl px-4 py-2"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "You're now editing this evaluation", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "w-full justify-between flex flex-row py-4" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "w-full justify-end flex flex-row" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M5 13l4 4L19 7"
  })
], -1)
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "flex flex-row w-full justify-between items-center" }
const _hoisted_21 = { class: "text-2xl font-extralight py-1 w-9/12" }
const _hoisted_22 = { class: "w-full py-2" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 3,
  class: ""
}
const _hoisted_25 = {
  key: 0,
  class: "w-full"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-700 font-bold" }, "File", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" }, null, -1)
const _hoisted_28 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScoreBar = _resolveComponent("ScoreBar")!
  const _component_CategoryAnswerArrayField = _resolveComponent("CategoryAnswerArrayField")!
  const _component_Button = _resolveComponent("Button")!
  const _component_WarningModal = _resolveComponent("WarningModal")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_PdfView = _resolveComponent("PdfView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.latestEvaluationAnswered)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (item, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "mr-2",
                  key: i
                }, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["inline-block p-2 border-b-2 cursor-pointer text-gray-300 border-b-2 border-gray-200 capitalize", {
              'border-b-2 border-primary  text-gray-600': _ctx.activeTab === i,
            }]),
                    onClick: ($event: any) => (_ctx.activeTab = i)
                  }, _toDisplayString(item), 11, _hoisted_4)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === 0 && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.title), 1),
              _createElementVNode("div", null, [
                (_ctx.isAnswered)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Answered "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_ScoreBar, {
                excellent: _ctx.score?.strong || 0,
                good: _ctx.score?.moderate || 0,
                bad: _ctx.score?.not_a_fit || 0
              }, null, 8, ["excellent", "good", "bad"])
            ]),
            (_ctx.isAnswered && !_ctx.isEditing && _ctx.currentStage === 'Screening')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              (_ctx.isEditing)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
              class: "w-full flex flex-col"
            }, [
              _createElementVNode("fieldset", {
                disabled: _ctx.currentStage !== 'Screening' && !_ctx.isEditing
              }, [
                _createVNode(_component_CategoryAnswerArrayField, {
                  errors: _ctx.errors,
                  isAnswered: _ctx.currentStage !== 'Screening' && !_ctx.isEditing
                }, null, 8, ["errors", "isAnswered"])
              ], 8, _hoisted_14),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_Button, {
                    onClick: [
                      _cache[0] || (_cache[0] = ($event: any) => (_ctx.setPreSave(false))),
                      _ctx.onSubmit
                    ],
                    label: "Save evaluation",
                    class: "disabled:cursor-not-allowed",
                    variant: "contained",
                    disabled: 
                !_ctx.meta.dirty || !_ctx.meta.valid || _ctx.currentStage !== 'Screening'
              
                  }, null, 8, ["onClick", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  (_ctx.isEditing)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        onOnClick: _ctx.editForm,
                        label: "Cancel",
                        class: "disabled:cursor-not-allowed mr-2",
                        variant: "outlined",
                        disabled: 
                !_ctx.meta.dirty || !_ctx.meta.valid || _ctx.currentStage !== 'Screening'
              
                      }, null, 8, ["onOnClick", "disabled"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_Button, {
                    onClick: [
                      _cache[1] || (_cache[1] = ($event: any) => (_ctx.setPreSave(true))),
                      _ctx.onSubmit
                    ],
                    label: !_ctx.isEditing ? 'Submit evaluation' : 'Save evaluation',
                    class: "disabled:cursor-not-allowed",
                    variant: "contained",
                    disabled: 
                !_ctx.meta.dirty || !_ctx.meta.valid || _ctx.currentStage !== 'Screening'
              
                  }, {
                    startIcon: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  }, 8, ["onClick", "label", "disabled"])
                ])
              ])
            ], 32),
            _createVNode(_component_ReusableModal, {
              show: _ctx.showModal,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setShowModal(false))),
              size: "w-6/12"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_WarningModal, {
                  onCloseModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setShowModal(false))),
                  onEmitAction: _ctx.saveChanges,
                  message: _ctx.message
                }, null, 8, ["onEmitAction", "message"])
              ]),
              _: 1
            }, 8, ["show"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === 1 && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.title), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_ScoreBar, {
                excellent: _ctx.score?.strong || 0,
                good: _ctx.score?.moderate || 0,
                bad: _ctx.score?.not_a_fit || 0
              }, null, 8, ["excellent", "good", "bad"])
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args))),
              class: "w-full flex flex-col"
            }, [
              _createElementVNode("fieldset", {
                disabled: _ctx.isAnswered && !_ctx.isEditing
              }, [
                _createVNode(_component_CategoryAnswerArrayField, {
                  errors: _ctx.errors,
                  isAnswered: _ctx.isAnswered && !_ctx.isEditing
                }, null, 8, ["errors", "isAnswered"])
              ], 8, _hoisted_23)
            ], 32)
          ]))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _createVNode(_component_Loader, { class: "mt-12" })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.file)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _hoisted_26,
          _hoisted_27,
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                (_openBlock(), _createBlock(_component_PdfView, {
                  key: undefined,
                  file: _ctx.file
                }, null, 8, ["file"]))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}